import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

import { colors } from "@dotnet/telematics-design-system";

const ErrorIcon = (props: SvgIconProps) => {
    const { red50, red700, white } = colors;

    return (
        <SvgIcon {...props}>
            <g fill="none">
                <rect
                    x="2.5"
                    y="2.5"
                    width="19"
                    height="19"
                    rx="9.5"
                    fill={white}
                    stroke={red700}
                />

                <rect
                    x="1"
                    y="1"
                    width="22"
                    height="22"
                    rx="11"
                    stroke={red50}
                    strokeWidth="2"
                />
            </g>
        </SvgIcon>
    );
};

export default ErrorIcon;
